import gql from 'graphql-tag'

export const queryCampaignsList = () => {
	return {
		query: gql`
			{
				campaigns: conf_campaigns {
					id
					name
					country {
						name
					}
					active
				}
			}
		`,
		update: data =>
			data.campaigns.map(item => ({
				id: item.id,
				name: item.name,
				country: item.country.name,
				edit: true,
				active: item.active
			}))
	}
}
